import { ID_OPPOSITION } from 'civil-status/components/step/form/last-step/accordions/section/list/list-opposition';
import { ID_PUBBLICATIONS } from 'civil-status/components/step/form/last-step/accordions/section/list/list-publication';
import { CodeSection } from 'civil-status/constants/code-subject-section';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { ID_APPLICANT } from 'civil-status/constants/id-applicant';
import { IDAssenzo2 } from 'civil-status/constants/id-assenso';
import { IDImpediment } from 'civil-status/constants/id-impediment';
import { MeasureExchangeSurnameID } from 'civil-status/constants/id-measure-exchange-surname';
import { IDMinorAssistance } from 'civil-status/constants/id-minor-assistance';
import { RiconoscimentoGenitoreItaliano } from 'civil-status/constants/id-riconoscimento-genitore-italiano';
import { IDSentenceRecognition } from 'civil-status/constants/id-sentence-recognition';
import { ID_TYPE_APPLICANT } from 'civil-status/constants/id-type-applicant';
import { IDTypeSeparation } from 'civil-status/constants/id-type-separation';
import { IDTypologyConsent } from 'civil-status/constants/id-typology-consent';
import { typePresence } from 'civil-status/constants/type-presence';
import { ParentVM, SectionVM } from 'civil-status/view-models/step-form';
import { CivilStatusID } from 'shell/constants/civil-status';
import { SectionWizardUseCase } from 'shell/models/subjects-wizard';

export const sectionIsVisibility = (
  itemSection?: SectionWizardUseCase | SectionVM,
  valuesDatiGeneraliConsenso?: SectionVM,
  valuesDatiSpecificiCittadinanza?: SectionVM,
  valuesIntNas?: ParentVM,
  valuesDatiTrascrizione?: SectionVM,
  valuesSpecificCivilUnionMarriage?: SectionVM,
  valuesRegimePatrimoniale?: SectionVM,
  valuesDatiSepar?: SectionVM,
  valuesDatiRiconciliazione?: SectionVM,
  valuesTrascrizioneCittadinanza?: SectionVM,
  valuesDeceduto?: ParentVM,
  isLastStepEmergency?: boolean
): boolean => {
  const presenza: string =
    (itemSection as SectionWizardUseCase)?.presenza ||
    (itemSection as SectionVM)?.typePresence ||
    '';

  if (
    presenza === typePresence.Obbligatorio ||
    presenza === typePresence.Facoltativo ||
    presenza === typePresence.FacoltativoObbligatorio ||
    presenza === typePresence.Default1
  ) {
    // se la sezione è obbligatoria, facoltativa o D1 mostrare sempre
    return true;
  }

  // Estrai il codice della sezione
  const codeSection: string =
    (itemSection as SectionWizardUseCase)?.key?.codSezione ||
    (itemSection as SectionVM)?.codeSection ||
    '';

  if (codeSection === CodeSection.AUTORIZZAZIONE_RICONOSCIMENTO_PADRE) {
    return valuesDatiGeneraliConsenso?.isIncestuousSonSentence || false;
  }

  if (codeSection === CodeSection.ATTO_DI_CONSENSO_ATCO) {
    return valuesDatiGeneraliConsenso?.typologyConsent === IDTypologyConsent.Consenso2;
  }

  if (codeSection === CodeSection.ATTO_DI_CONSENSO_ATCOP) {
    return valuesDatiGeneraliConsenso?.typologyConsent === IDTypologyConsent.Consenso2;
  }

  if (codeSection === CodeSection.ATTO_DI_CONSENSO_ED) {
    return valuesDatiGeneraliConsenso?.typologyConsent === IDTypologyConsent.Consenso3;
  }

  if (codeSection === CodeSection.CONSENSO_ATTO) {
    return valuesSpecificCivilUnionMarriage?.typologyConsent === IDTypologyConsent.Consenso2;
  }

  if (codeSection === CodeSection.CONSENSO_ALTRO) {
    return valuesSpecificCivilUnionMarriage?.typologyConsent === IDTypologyConsent.Consenso3;
  }

  if (
    codeSection === CodeSection.CONSENSO_SENTENZA ||
    codeSection === CodeSection.SENTENZA_CONSENSO
  ) {
    return (
      valuesDatiGeneraliConsenso?.typologyConsent === IDTypologyConsent.Consenso4 ||
      valuesDatiSepar?.typologyConsent === IDTypologyConsent.Consenso4 ||
      valuesSpecificCivilUnionMarriage?.typologyConsent === IDTypologyConsent.Consenso4
    );
  }

  if (
    codeSection === CodeSection.ATTO_ASSENSO_FIGLIO ||
    codeSection === CodeSection.ATTO_ASSENSO_FIGLIO_RESO
  ) {
    return valuesDatiGeneraliConsenso?.typeDeclaration === IDAssenzo2;
  }

  if (codeSection === CodeSection.ATTO_RICONOSCIMENTO) {
    return (
      valuesDatiGeneraliConsenso?.parentRecognition === RiconoscimentoGenitoreItaliano.Entrambi ||
      valuesDatiTrascrizione?.parentRecognition === RiconoscimentoGenitoreItaliano.Entrambi
    );
  }

  if (codeSection === CodeSection.ATTO_RICONOSCIMENTO_MADRE) {
    return (
      valuesDatiGeneraliConsenso?.parentRecognition === RiconoscimentoGenitoreItaliano.Madre ||
      valuesDatiTrascrizione?.parentRecognition === RiconoscimentoGenitoreItaliano.Madre
    );
  }

  if (codeSection === CodeSection.ATTO_RICONOSCIMENTO_PADRE) {
    return (
      (valuesDatiGeneraliConsenso &&
        valuesDatiGeneraliConsenso.configuration === ConfigurationType.DSNAS01 &&
        !valuesDatiGeneraliConsenso?.isPaternitySentence) ||
      (valuesDatiTrascrizione?.configuration === ConfigurationType.DSNAS01 &&
        !valuesDatiTrascrizione?.isPaternitySentence) ||
      valuesDatiGeneraliConsenso?.parentRecognition === RiconoscimentoGenitoreItaliano.Padre ||
      valuesDatiTrascrizione?.parentRecognition === RiconoscimentoGenitoreItaliano.Padre
    );
  }

  if (codeSection === CodeSection.ESTREMI_SENTENZA_MADRE) {
    return (
      valuesDatiSpecificiCittadinanza?.sentenceRecognition === IDSentenceRecognition.Riconoscimento4
    );
  }

  if (codeSection === CodeSection.ESTREMI_SENTENZA_PADRE) {
    return (
      valuesDatiSpecificiCittadinanza?.sentenceRecognition ===
        IDSentenceRecognition.Riconoscimento3 ||
      valuesDatiGeneraliConsenso?.isPaternitySentence ||
      valuesDatiTrascrizione?.isPaternitySentence ||
      false
    );
  }

  if (codeSection === CodeSection.ATTO_CONSENSO_ATCOP) {
    return (
      valuesDatiSpecificiCittadinanza?.sentenceRecognition === IDSentenceRecognition.Riconoscimento2
    );
  }

  if (codeSection === CodeSection.ATTO_CONSENSO_ATCOM) {
    return (
      valuesDatiSpecificiCittadinanza?.sentenceRecognition === IDSentenceRecognition.Riconoscimento1
    );
  }

  if (codeSection === CodeSection.ATTO_NASCITA_CONIUGE) {
    // Se è la sezione dell'atto di nascita del coniuge
    return (
      valuesIntNas?.generality?.civilStatusItem?.id?.toString() === CivilStatusID.coniugato ||
      valuesIntNas?.generality?.civilStatusItem?.id?.toString() === CivilStatusID.vedovo
    );
  }

  if (codeSection === CodeSection.ATTO_MATRIMONIO) {
    // Se è la sezione dell'atto di matrimonio
    return (
      valuesIntNas?.generality?.civilStatusItem?.id?.toString() === CivilStatusID.coniugato ||
      valuesDeceduto?.generality?.civilStatusItem?.id?.toString() === CivilStatusID.coniugato
    );
  }

  if (codeSection === CodeSection.ATTO_UNIONE_CIVILE) {
    // Se è la sezione dell'atto di unione civile
    return (
      valuesIntNas?.generality?.civilStatusItem?.id?.toString() === CivilStatusID.unitoCivilmente ||
      valuesDeceduto?.generality?.civilStatusItem?.id?.toString() === CivilStatusID.unitoCivilmente
    );
  }

  if (codeSection === CodeSection.ATTO_NASCITA_UNITO) {
    // Se è la sezione dell'atto di nascita dell'unito
    return (
      valuesIntNas?.generality?.civilStatusItem?.id?.toString() === CivilStatusID.unitoCivilmente ||
      valuesIntNas?.generality?.civilStatusItem?.id?.toString() ===
        CivilStatusID.scioglimentoUnitoCivilmenteASeguitoDelDecesso
    );
  }

  if (codeSection === CodeSection.DATI_PROVCOM) {
    return valuesDatiTrascrizione?.measureExchangeSurname === MeasureExchangeSurnameID.Prefettura;
  }

  if (codeSection === CodeSection.DATI_TRASCRIZIONE_RICHIEDENTE) {
    return valuesDatiTrascrizione?.typeApplicant === ID_TYPE_APPLICANT.Pubblico;
  }

  if (codeSection === CodeSection.PROVVEDIMENTO_ESTINZIONE_OPPOSIZIONE) {
    return valuesSpecificCivilUnionMarriage?.opposition === ID_OPPOSITION.ID_PROVVEDIMENTO;
  }

  if (codeSection === CodeSection.PROVVEDIMENTO_RIGETTO_OPPOSIZIONE) {
    return valuesSpecificCivilUnionMarriage?.opposition === ID_OPPOSITION.ID_DECRETO;
  }

  if (codeSection === CodeSection.CERT_IMPEDIMENTO_GENERICO) {
    return (
      Boolean(valuesSpecificCivilUnionMarriage?.genericImpediment) &&
      valuesSpecificCivilUnionMarriage?.genericImpediment !== '0'
    );
  }

  if (codeSection === CodeSection.CERT_IMPEDIMENTO_SPOSO) {
    return (
      (Boolean(valuesSpecificCivilUnionMarriage?.impedimentUnitedCivilly) &&
        valuesSpecificCivilUnionMarriage?.impedimentUnitedCivilly === IDImpediment.Sposo) ||
      valuesSpecificCivilUnionMarriage?.impedimentUnitedCivilly === IDImpediment.Entrambi
    );
  }

  if (codeSection === CodeSection.CERT_IMPEDIMENTO_SPOSA) {
    return (
      (Boolean(valuesSpecificCivilUnionMarriage?.impedimentUnitedCivilly) &&
        valuesSpecificCivilUnionMarriage?.impedimentUnitedCivilly === IDImpediment.Sposa) ||
      valuesSpecificCivilUnionMarriage?.impedimentUnitedCivilly === IDImpediment.Entrambi
    );
  }

  if (codeSection === CodeSection.PUBBLICAZIONE_2) {
    return (
      valuesSpecificCivilUnionMarriage?.publication === ID_PUBBLICATIONS.ID_PUBBLICATION_OCCURRED
    );
  }

  if (codeSection === CodeSection.MATRIMONIO_SENTENZA_OMISSIONE_PUBBLICAZIONE) {
    return (
      valuesSpecificCivilUnionMarriage?.publication === ID_PUBBLICATIONS.ID_PUBBLICATION_OMISSION
    );
  }

  if (codeSection === CodeSection.PUBBLICAZIONE_1) {
    return (
      Boolean(valuesSpecificCivilUnionMarriage?.publication) &&
      valuesSpecificCivilUnionMarriage?.publication !== ID_PUBBLICATIONS.ID_PUBBLICATION_OMISSION
    );
  }

  if (codeSection === CodeSection.MATRIMONIO_AUTORIZZAZIONE_DIFETTO_ETA) {
    return (
      Boolean(valuesSpecificCivilUnionMarriage?.ageDefect) &&
      valuesSpecificCivilUnionMarriage?.ageDefect !== '1'
    );
  }

  if (codeSection === CodeSection.MATRIMONIO_AUTORIZZAZIONE_DIVIETO_TEMP) {
    return Boolean(valuesSpecificCivilUnionMarriage?.isTemporaryBanRemarriage);
  }

  if (codeSection === CodeSection.MATRIMONIO_AUTORIZZAZIONE_PARENTELA) {
    return (
      Boolean(valuesSpecificCivilUnionMarriage?.relationship) &&
      valuesSpecificCivilUnionMarriage?.relationship !== '0'
    );
  }

  if (codeSection === CodeSection.MATRIMONIO_NOMINA_ASSISTENTE_LEGALE_SPOSO) {
    return (
      valuesSpecificCivilUnionMarriage?.minorGroomAssistance === IDMinorAssistance.Tutore ||
      valuesSpecificCivilUnionMarriage?.minorGroomAssistance === IDMinorAssistance.Curatore
    );
  }

  if (codeSection === CodeSection.MATRIMONIO_NOMINA_ASSISTENTE_LEGALE_SPOSA) {
    return (
      valuesSpecificCivilUnionMarriage?.minorWifeAssistance === IDMinorAssistance.Tutore ||
      valuesSpecificCivilUnionMarriage?.minorWifeAssistance === IDMinorAssistance.Curatore
    );
  }

  if (codeSection === CodeSection.ASSENSO_FIGLIO) {
    return (
      Boolean(valuesSpecificCivilUnionMarriage) &&
      !valuesSpecificCivilUnionMarriage?.isSonUnderFourteen
    );
  }

  if (codeSection === CodeSection.ANNOTAZIONE_CONTESTUALE) {
    return (
      Boolean(valuesRegimePatrimoniale?.propertyRegime) &&
      valuesRegimePatrimoniale?.propertyRegime !== '1'
    );
  }

  if (codeSection === CodeSection.PROVVEDIMENTO_SEPARAZIONE) {
    return (
      valuesDatiSepar?.typeSeparation === IDTypeSeparation.Provvedimento ||
      valuesDatiRiconciliazione?.typeSeparation === IDTypeSeparation.Provvedimento
    );
  }

  if (codeSection === CodeSection.NEGOZIAZIONE_ASSISTITA) {
    return (
      valuesDatiSepar?.typeSeparation === IDTypeSeparation.NegoziazioneAssistita ||
      valuesDatiRiconciliazione?.typeSeparation === IDTypeSeparation.NegoziazioneAssistita
    );
  }

  if (codeSection === CodeSection.ACCORDO_SEPARAZIONE) {
    return (
      valuesDatiSepar?.typeSeparation === IDTypeSeparation.Accordo ||
      valuesDatiSepar?.typeSeparation === IDTypeSeparation.NegoziazioneAssistita ||
      valuesDatiSepar?.typeSeparation === IDTypeSeparation.AccordoCheHaDeterminatoIlDivorzio ||
      valuesDatiRiconciliazione?.typeSeparation === IDTypeSeparation.Accordo ||
      valuesDatiRiconciliazione?.typeSeparation === IDTypeSeparation.NegoziazioneAssistita ||
      valuesDatiRiconciliazione?.typeSeparation ===
        IDTypeSeparation.AccordoCheHaDeterminatoIlDivorzio
    );
  }

  if (codeSection === CodeSection.CONFERMA_ACCORDO_SEP) {
    return (
      valuesDatiSepar?.typeSeparation === IDTypeSeparation.Accordo ||
      valuesDatiSepar?.typeSeparation === IDTypeSeparation.AccordoCheHaDeterminatoIlDivorzio ||
      valuesDatiRiconciliazione?.typeSeparation === IDTypeSeparation.Accordo ||
      valuesDatiRiconciliazione?.typeSeparation ===
        IDTypeSeparation.AccordoCheHaDeterminatoIlDivorzio
    );
  }

  if (codeSection === CodeSection.DATI_AUTORITA_MITTENTE) {
    return (
      (Boolean(valuesDatiSepar) &&
        !valuesDatiSepar?.isReceivedPrivateCitizen &&
        !valuesDatiTrascrizione) ||
      valuesDatiTrascrizione?.applicant?.id?.toString() === ID_APPLICANT.AUTORITA_GIURISDIZIONALE
    );
  }

  if (codeSection === CodeSection.DATI_EVENTO_CITTADINANZA) {
    return (
      (Boolean(valuesTrascrizioneCittadinanza) &&
        valuesTrascrizioneCittadinanza?.isReceivedByPost) ||
      false
    );
  }

  if (codeSection === CodeSection.DATI_TRASCRIZIONE_CITTADINANZA) {
    return !(
      Boolean(valuesTrascrizioneCittadinanza) && valuesTrascrizioneCittadinanza?.isReceivedByPost
    );
  }

  if (codeSection === CodeSection.DATI_REGISTRO_EMERGENZA) {
    return isLastStepEmergency || false;
  }

  // Mostra la sezione per default
  return true;
};
